import { topicListAPI } from '@/providers/apis/topic-list/topic-list';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mediaAPI } from '@/providers/apis/media/media';
import { checkCDNUrl } from '@/utils/utils';

@Component({
    name: 'create-topic',
})

export default class CreateTopic extends Vue {
    public form: any = {
        topicName: null,
        subjectName: null,
        gradeName: null,
        framework: null,
        levelName: null,
        sequence: '1',
        tenant: null,
        accessControl: true,
        description: 'This subject covers foundational math for grades 1–8.',
        thumbnail: null,
    };
    public isSubjectLoading: boolean = true;
    public isFrameworkLoading: boolean = false;
    public isLevelLoading: boolean = false;
    public isMarkerLoading: boolean = false;
    public isTenantLoading: boolean = true;
    public errors: any = {
        topicName: '',
        subjectName: '',
        framework: '',
        levelName: '',
        markerId: '',
        tenant: '',
    };
    public isLoading: boolean = true;
    @Prop()
    public isEditTopic: any;
    @Prop()
    public subjectList: any;
    @Prop()
    public levelList: any;
    @Prop()
    public tenantList: any;
    @Prop()
    public selectedTopic: any;
    public selectedThumbnail: any = '';
    public subjectOptions: any = [];
    public levelOptions: any = [];
    public frameworkOptions: any = [];
    public sequenceOptions = ['1', '2', '3'];
    public markerOptions: any = [];
    public tenantOptions: any = [];
    public selectedSubject: any;
    public selectedGrade: any;
    public handleSubmit() {
        if (!this.validateForm()) { return; }
        const data = {
            topic: this.form.topicName,
            marker_id: this.form.markerId,
            common_grade: [this.selectedGrade.commonGrade],
            subjects: [
                {
                    title: this.selectedSubject.text,
                    code: this.selectedSubject.subjectCode,
                },
            ],
        };
        topicListAPI.createTopic(data);
        this.$emit('onGoBack');

    }
    public validateForm() {
        let isValid = true;
        this.errors = {
            topicName: '',
            subjectName: '',
            framework: '',
            levelName: '',
            markerId: '',
            tenant: '',
        };

        if (!this.form.topicName) {
            this.errors.topicName = 'Topic name is required';
            isValid = false;
        }
        if (!this.form.subjectName) {
            this.errors.subjectName = 'Subject name is required';
            isValid = false;
        }
        if (!this.form.framework) {
            this.errors.framework = 'Framework is required';
            isValid = false;
        }
        if (!this.form.levelName) {
            this.errors.levelName = 'Grade is required';
            isValid = false;
        }
        if (!this.form.markerId) {
            this.errors.markerId = 'Marker is required';
            isValid = false;
        }
        // if (!this.form.tenant) {
        //   this.errors.tenant = 'Tenant is required';
        //   isValid = false;
        // }

        return isValid;
    }
    public handleUpdate() {
        if (!this.validateForm()) { return; }
        const data = {
            title: this.form.topicName,
            marker_id: this.form.markerId,
            common_grade: [this.selectedGrade.commonGrade],
            subjects: [
                {
                    title: this.selectedSubject.text,
                    code: this.selectedSubject.subjectCode,
                },
            ],
        };
        topicListAPI.updateTopic(data, this.selectedTopic.id);
        this.$emit('onGoBack');
    }
    public onCancel() {
        this.$emit('cancel');
    }
    public onGoback() {
        this.$emit('onGoBack');
    }

    public triggerThumbnailUpload() {
        const input = this.$refs.thumbnailInput as HTMLInputElement | undefined;
        if (input) {
            input.click();
        }
    }

    public async handleThumbnailChange(event: Event) {
        const target = event.target as HTMLInputElement;
        const file = target.files && target.files[0];
        if (file) {
            this.selectedThumbnail = file.name;
            const thumbnailImage = this.form.thumbnail = file ? await this.uploadImage(file) : null;
            this.form.thumbnail = thumbnailImage;
        }
    }

    public async uploadImage(iterator: any) {
        return mediaAPI.uploadFile(iterator, 'image').then((fileData) => {
            return checkCDNUrl(fileData.filename);
        });
    }


    public async created() {
        this.isTenantLoading = true;
        this.isSubjectLoading = true;
        this.subjectOptions = this.subjectList.map((item: any) => ({
            value: item.key,
            text: item.title,
            framework: item.fw_code,
            subjectCode: item.subject_code,
            key: item.key,
        }));
        this.isSubjectLoading = false;
        this.tenantOptions = await topicListAPI.getTenants();
        this.isTenantLoading = false;
        if (this.selectedTopic) {
            this.form.topicName = this.selectedTopic.topicname;
            const matchedSubject = this.subjectOptions.find(
                (opt: any) => opt.subjectCode === this.selectedTopic.subject[0].code,
            );
            this.form.subjectName = matchedSubject.value || null;
            this.frameworkOptions = [{
                value: matchedSubject.value,
                text: matchedSubject.framework,
                subjectCode: matchedSubject.subjectCode,
            }];
            this.form.markerId = this.selectedTopic.id || null;
            this.form.framework = this.frameworkOptions[0].value || null;
            this.isFrameworkLoading = true;
            await this.onSelectSubject(this.form.subjectName);
            this.isFrameworkLoading = false;
            this.isLevelLoading = true;
            await this.onSelectFramework(this.form.framework);
            this.isLevelLoading = false;
            const matchedGrade = this.levelOptions.find(
                (opt: any) => opt.text === this.selectedTopic.grade,
            );
            this.form.levelName = matchedGrade.value || null;
            this.selectedGrade = matchedGrade;
        }
    }

    public async onSelectSubject(selectedId: number) {
        const selectedSubject = this.subjectOptions.find((subject: any) => subject.key === selectedId);
        this.selectedSubject = selectedSubject;
        if (selectedSubject) {
            this.frameworkOptions = [
                {
                    value: selectedSubject.value,
                    text: selectedSubject.framework,
                    subjectCode: selectedSubject.subjectCode,
                },
            ];
            const fwCode = this.frameworkOptions[0].text;
            const subjectCode = this.frameworkOptions[0].subjectCode;
            const params: any = {
                frameworkCode: fwCode,
                subjectCode,
            };
            this.isMarkerLoading = true;
            try {
                const marker = await topicListAPI.getMarkers(params);
                this.markerOptions = marker.map((item: any) => ({
                    value: item.id,
                    text: item.name,
                }));
            } catch (e) {
                this.markerOptions = [];
            } finally {
                this.isMarkerLoading = false;
            }
        }
    }

    public async onSelectFramework(selectedId: any) {
        const selectedFramework = this.frameworkOptions.find((framework: any) => framework.value === selectedId);
        if (selectedFramework) {
            try {
                const levels = await topicListAPI.getLevels(selectedFramework.value);
                this.levelOptions = levels.map((level: any) => ({
                    value: level.grade_id,
                    text: level.title,
                    commonGrade: level.common_grade,
                }));
            } catch (error) {
                this.levelOptions = [];
            }
        }
    }

    public async onSelectGrade(selectedId: any) {
        const selectedGrade = this.levelOptions.find((level: any) => level.value === selectedId);
        if (selectedGrade) {
            this.selectedGrade = selectedGrade;
        }
    }

}
